import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Link from "../components/Link"
import Menu from "../components/Menu"

import EmentoLogo from "../../static/svg/emento_logo.svg";

const Header = ({ siteTitle }) => {
  const [scrolled, setScrolled] = useState(false)
  const [loaded, setLoaded] = useState(false)
  
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", () =>
        setScrolled(window.pageYOffset > 1)
      )
    }
    setLoaded(true)
  }, [])

  return (
  <header
  className={`l-site-header wide-container ${
    scrolled ? "has-scrolled" : "not-scrolled"
  } ${loaded ? "has-loaded" : "not-loaded"}`}
>
<div className="wide-inner">

    <div className="inner">
      <div className="logo">
        <Link to="/">
          <EmentoLogo className="emento_header_logo" />
        </Link>
      </div>
      <div className="header-space"></div>
      <Menu />
    </div>
    </div>
  </header>
)
  }

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
